import server from "./server";

export const postUserLogin = async (data) => {
  const response = await server().post("/auth/login", data);

  return response.data;
};

export const postUserRegister = async ({ searchParams, data }) => {
  const response = await server().post(`/auth/register?${searchParams}`, data);

  return response.data;
};

export const getInvitationApi = async (code) => {
  const response = await server().get(`/employees/invitation/${code}`);

  return response.data;
};

export const getCurrentUser = async (data) => {
  const response = await server().get("/users/profile", data);

  return response.data;
};

export const editProfileApi = async ({ data }) => {
  const response = await server().put("/users/profile", data);
  return response.data;
};